import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { UiThemeService } from '../ui-theme.service';

@Component({
  selector: 'am-theme-toggle',
  template: `
    <ng-container *ngIf="theme.theme$ | async as _theme">
      <button
        matTooltip="Toggle Theme"
        mat-icon-button
        (click)="theme.toggleTheme()"
        role="button"
      >
        <am-icon
          role="img"
          [name]="theme.darkThemeEnabled ? 'sun' : 'moon'"
        ></am-icon>
      </button>
    </ng-container>
  `,
})
export class ThemeToggleComponent {
  constructor(
    @Inject(DOCUMENT) private document: any,
    public theme: UiThemeService,
    private renderer: Renderer2
  ) {
    theme.init(renderer, document);
  }
}
